import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';
import { CertificateService } from 'app/library/certificate/services/certificate.service';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';
import { FinalGradeService } from 'app/library/final-grade/services/final-grade.service';
import { ModuleCertificateExtended } from 'app/library/module-certificate/models/module-certificate.extended.model';
import { ModuleCertificatesService } from 'app/library/module-certificates/services/module-certificates.service';
import { ModuleEventAttendanceService } from 'app/library/module-event-attendance/services/module-event-attendance.service';
import { ModuleFeatureService } from 'app/library/module-feature/services/module-feature.service';
import { ModuleUserProgressStatus } from 'app/library/module-user/enums/module-user-progress-status.enum';
import { ModuleCompletitionStatuses } from 'app/library/module-user/models/module-completition-status';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { SectionRule } from 'app/library/module/enums/sectionRule.enum';
import { Module } from 'app/library/module/models/module.model';
import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';
import { PartialGradeService } from 'app/library/partial-grade/services/partial-grade.service';
import { ProgramItemsWithGroup } from 'app/library/program-item/models/program-items-with-group.model';
import { ProgramStructureWithProgramParticipant } from 'app/library/program-item/models/program-structure-with-program-participant.model';
import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { ProgramItemService } from 'app/library/program-item/services/program-item.service';
import { Team } from 'app/library/team/models/team.model';
import { TeamService } from 'app/library/team/services/team.service';
import { UserSectionStats } from 'app/library/user-section/models/user-section.model';
import { UserSectionStatsState } from 'app/library/user-section/models/user-section.state';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { FuseConfigService } from 'app/projects/fuse/src/lib/services/config.service';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { ModuleFeatureSwitchName } from 'app/projects/shared/src/lib/enums/module-feature-switch.enum';
import { ILanguageService } from 'app/projects/shared/src/lib/interfaces/language.interface';
import { FeatureSwitchPipe } from 'app/projects/shared/src/lib/pipes/feature-switch.pipe';
import { MAXBRAIN_LANGUAGE_SERVICE } from 'app/projects/shared/src/lib/services/language.token';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CourseAttendanceDialogComponent } from '../course-attendance-dialog/course-attendance-dialog.component';

@Component({
    selector: 'app-team-program-member-details-dialog',
    templateUrl: './team-program-member-details-dialog.component.html',
    styleUrls: ['./team-program-member-details-dialog.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class TeamProgramMemberDetailsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    currentModule: Module;

    @Select(UserSectionStatsState.getEntities)
    userSectionStats$: Observable<UserSectionStats[]>;

    confirmDialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>;

    fuseConfig: any;
    ModuleKind = ModuleKind;
    tabLinks = [];
    usedModuleCertificates: SimpleCertificate[];

    rippleDisabled = false;
    finalGrades: FinalGrade[];
    partialGrades: PartialGrade[];
    moduleCertificates: ModuleCertificateExtended[] = [];
    attendanceDialogRef: MatDialogRef<CourseAttendanceDialogComponent>;
    user: User;

    isCurrentUserTenantAdmin: boolean;
    isGradebookFeatureEnabled: boolean;
    isModuleFeatureAttendanceActive: boolean;

    SectionRule = SectionRule;
    ModuleType = ModuleType;
    ModuleUserProgressStatus = ModuleUserProgressStatus;
    moduleCompletitionStatus = ModuleCompletitionStatuses;
    programStructureWithProgramParticipant: ProgramStructureWithProgramParticipant;
    initialProgramStructure: ProgramStructureWithProgramParticipant;
    programStructure: ProgramItemsWithGroup[];
    team: Team;
    initialLoad: boolean = true;

    moduleId: string;
    title: string;
    participantId: string;

    isDataFetched: boolean = false;

    get isAtRootLevel(): boolean {
        return this.programStructureWithProgramParticipant?.programParticipant.id === this.initialProgramStructure?.programParticipant?.id;
    }

    constructor(
        public programItemService: ProgramItemService,
        public dialogRef: MatDialogRef<TeamProgramMemberDetailsDialogComponent>,
        public certificateService: CertificateService,
        private _fuseConfigService: FuseConfigService,
        private _store: Store,
        private _finalGradeService: FinalGradeService,
        private _moduleCertificatesService: ModuleCertificatesService,
        private _partialGradeService: PartialGradeService,
        private _featureSwitchPipe: FeatureSwitchPipe,
        private _moduleFeatureService: ModuleFeatureService,
        private _matDialog: MatDialog,
        private _moduleEventAttendanceService: ModuleEventAttendanceService,
        private _teamService: TeamService,
        @Inject(MAXBRAIN_LANGUAGE_SERVICE) public languageService: ILanguageService,
        @Inject(MAT_DIALOG_DATA) public data: { moduleId: string; title: string; participantId: string }
    ) {
        super();

        this.moduleId = data.moduleId;
        this.title = data.title;
        this.participantId = data.participantId;

        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
            },
        };

        this.team = this._teamService.getCurrentTeam();

        // Subscribe to config changes
        this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
            this.fuseConfig = config;
        });

        this._finalGradeService.moduleFinalGrade$.pipe(takeUntil(this._unsubscribeAll)).subscribe((finalGrades) => {
            this.finalGrades = finalGrades;
        });

        this._partialGradeService.currentUserPartialGrade$.pipe(takeUntil(this._unsubscribeAll)).subscribe((partialGrades) => {
            this.partialGrades = partialGrades;
        });

        this.isGradebookFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.Gradebook);
        this.isModuleFeatureAttendanceActive = this._moduleFeatureService.checkModuleFeatureStatus(ModuleFeatureSwitchName.Attendance);
    }

    async ngOnInit(): Promise<void> {
        this.user = this._store.selectSnapshot(UserState.getMyInfo);
        this.isCurrentUserTenantAdmin = this.user.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);

        this.moduleCertificates = this._moduleCertificatesService.getModuleCertificates();

        await this.programItemService.fetchTeamParticipantProgramExecution(this.team.id, this.moduleId, this.participantId);
        this.isDataFetched = true;

        this.programItemService.programStructureWithProgramParticipantSubject$
            .pipe(distinctUntilChanged(), takeUntil(this._unsubscribeAll))
            .subscribe(async (programStructureWithProgramParticipant) => {
                if (programStructureWithProgramParticipant) {
                    this.programStructureWithProgramParticipant = programStructureWithProgramParticipant;

                    if (!this.initialProgramStructure) {
                        this.initialProgramStructure = programStructureWithProgramParticipant;
                    }

                    const initialStructure = programStructureWithProgramParticipant.programStructure;
                    const programModuleId =
                        this.initialLoad || !programStructureWithProgramParticipant?.programParticipant?.module?.id
                            ? this.moduleId
                            : programStructureWithProgramParticipant.programParticipant.module.id;

                    // Step 1: Start all fetches in parallel without mutating anything
                    const fetchPromises = initialStructure.map((programItemWithGroup) => {
                        const courseGroupId = programItemWithGroup.group.id;

                        return this.programItemService.fetchTeamParticipantProgramExecutionGroup(
                            this.team.id,
                            programModuleId,
                            courseGroupId,
                            this.participantId
                        );
                    });

                    // Step 2: Wait for all fetches to complete
                    const fetchedData = await Promise.all(fetchPromises);
                    this.initialLoad = false;

                    // Step 3: Now map the results to merge the fetched data into the initial structure
                    const updatedStructure = initialStructure.map((programItemWithGroup, index) => {
                        const fullGroupData = fetchedData[index];

                        return {
                            ...programItemWithGroup,
                            groupStatsCoursesBooked: fullGroupData?.groupStatsCoursesBooked,
                            groupStatsCoursesCompleted: fullGroupData?.groupStatsCoursesCompleted,
                            programItems: fullGroupData?.programItems?.length ? [...fullGroupData.programItems] : [],
                            isExpanded: fullGroupData?.isExpanded,
                        };
                    });

                    this.programStructure = updatedStructure;

                    const isAnyExpanded = this.programStructure.some((group) => group.isExpanded);

                    if (!isAnyExpanded) {
                        for (let group of this.programStructure) {
                            if (group.groupStatsCoursesBooked > group.groupStatsCoursesCompleted) {
                                group.isExpanded = true;
                                break;
                            }
                        }
                    }
                }
            });
    }

    async goBack(): Promise<void> {
        this.initialLoad = true;
        await this.programItemService.fetchTeamParticipantProgramExecution(this.team.id, this.moduleId, this.participantId);
    }

    async openCourseAttendanceDialog(courseOfferingName: string, relevantExecution: RelevantExecution): Promise<void> {
        await this._moduleEventAttendanceService.getParticipantAttendances(relevantExecution.id, this.participantId);

        this.attendanceDialogRef = this._matDialog.open(CourseAttendanceDialogComponent, {
            width: '700px',
        });

        this.attendanceDialogRef.componentInstance.moduleName = courseOfferingName;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
